/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable import/max-dependencies */
/* eslint-disable max-lines, complexity, max-statements, no-param-reassign, max-len */
import React, {
  useEffect,
  useState,
  useCallback,
  memo,
  useMemo,
} from 'react'
import { useResponsiveWrapperContext } from '@usap/uicomponents'
import { idleCallback } from '@usap/core'
import axios from 'axios'
import urlDecode from '../../helpers/urlDecode'
import { queryFactory } from '../../helpers'
import localConfig from '../../../config/local-config'
import apiConfig from '../../../config/api-config'
import validateAndUpdateVehicle from '../../helpers/validateAndUpdateVehicle'
import VSLayout from '../vsComponent'
import nrLogger from '../../helpers/nrLogger'
import { useVehicleContext } from '../../contexts/vehicle.context'
import { useSerpContext } from '../../contexts/serp.context'
import useVehicleController from '../../controllers/vehicle.controller'
import usePLAController from '../../controllers/pla.controller'
import {
  isPla,
  getSequence,
  getAttributes,
  getElementByKey,
  getMetaFromAPI,
  isYearRangePla,
  getYearRangeInitialData,
  getYearRange,
  deepClone,
  getSelectedKeyword,
  hasFullVehicleInfoPLA,
  hasFullVehicleInfoNotPLA,
  canAddVehiclePLA,
  isSEOPage,
  getSEOInitialData,
} from '../../helpers/searchBoxFactory'
import useIsMounted from '../../../hooks/useIsMounted'
import expandMobile from '../vsComponent/expandMobile'
import { noBannerYMMPages } from '../HeaderWmo'

let flagCheck = false
const elsSearchURL = `${apiConfig.apiURL}/vehicle?op={{api}}&{{apiProps}}&pipeDelimited=1`
const vehicleCheckList = ['vlp', 'year_make_model', 'mntlist', 'mntsrp']

const findByKey = (data, key, value) => data.find(element => element[key] === value)
const cleanupOptionAndDisabled = (data, keys) => data.map(element => ({
  ...element,
  disabled: !keys.includes(element.key),
  options: keys.includes(element.key) ? element.options : [],
  value: keys.slice(0, -1).includes(element.key) ? element.value : '',
}))

const getInitialVehicleData = (selectBoxes, years) => ({
  meta: selectBoxes.map(element => ({
    ...element,
    options: element.key === 'year' && element.api !== 'getYearsByMakeModel' ? years : element.options,
  })),
  selectedData: {},
  isValid: false,
})

const SearchBox = props => {
  const {
    originalDynamicApiData,
    dynamicApiData: {
      years: yearsInt,
      pageType,
      productDetails = {},
      selectedAttributes = {},
    },
    history,
    apiDetails: {
      props: {
        selectBoxes: selectBoxesOriginal = [],
        urlSequence = [],
      } = {},
    },
    width = '1248px',
    showIcon = true,
    addGarageVehicle,
  } = props

  const vehicleState = useVehicleContext()
  const {
    addVehicle,
    showVehicleSelector,
    updateVehicles,
  } = useVehicleController()

  const { updatePLA } = usePLAController()
  const serpState = useSerpContext()
  const { isDesktop } = useResponsiveWrapperContext()
  const { bypassRoutesForVehicle } = localConfig
  const years = (yearsInt || []).map(String)
  const isHomePage = pageType === 'home'
  const isCart = Boolean((__BROWSER__ && window.location.pathname.indexOf('/cart') > -1) || pageType === 'cart')
  const isIframe = __BROWSER__ && window.location.href.indexOf('iframe=1') > -1

  const selectBoxes = expandMobile(selectBoxesOriginal, pageType)
  const isMounted = useIsMounted()
  const [vehicleData, setVehicleData] = useState(getInitialVehicleData(selectBoxes, years))
  const [isPlaPage, setIsPla] = useState(false)
  const [showLoader, setLoader] = useState(false)

  // Set ISPDP
  useEffect(() => {
    const hasPla = isPla(productDetails)
    const pdpPageType = (window.pageType || '').includes('sku')
    if (__BROWSER__ && pdpPageType && hasPla) {
      setIsPla(true)
    }
  }, [productDetails, years])

  const requiredSelection = useMemo(() => selectBoxes.reduce((requiredKeys, element) => {
    if (element.required) requiredKeys.push(element.key)
    return requiredKeys
  }, []), [selectBoxes])

  const fromCartItem = useMemo(() => Boolean(
    vehicleState &&
      vehicleState.cartVehicleDB &&
      vehicleState.cartVehicleDB.itemId,
  ), [vehicleState])

  useEffect(() => {
    if (vehicleState.changeVehicleAction) {
      const vehicleDB = vehicleState.vehicleDB || []
      const selectedVehicle = vehicleDB.find(vehicle => vehicle.selected)
      if (selectedVehicle) {
        const { ...rest } = selectedVehicle
        const sequence = getSequence()
        const attributesData = getAttributes(
          { attributes: rest },
          sequence,
          true,
        )
        if (attributesData && attributesData.sequence.length !== 5) {
          attributesData.sequence.push(
            sequence[attributesData.sequence.length],
          )
        }
        let vehicleMeta = [...vehicleData.meta]
        vehicleMeta = vehicleMeta.map(element => {
          element.isMobile = true
          return element
        })
        getMetaFromAPI(attributesData, { meta: vehicleMeta }, years)
          .then(updatedData => {
            setVehicleData({
              ...vehicleData,
              meta: updatedData,
              selectedData: rest || {},
              isValid: Object.keys(rest || {}).length >= 3,
            })
          })
          .finally(() => {
            setLoader(false)
            updateVehicles({ changeVehicleAction: false })
          })
      } else {
        updateVehicles({ changeVehicleAction: false })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicleState.changeVehicleAction])

  const setVehicleDataContext = responseData => {
    idleCallback(() => {
      setLoader(false)
      return setVehicleData(responseData)
    })
  }
  // SEO page
  useEffect(() => {
    const hasSEOPage = isSEOPage(pageType, originalDynamicApiData)
    if (hasSEOPage && selectedAttributes && Object.keys(selectedAttributes).length) {
      const sequence = getSequence(true)
      const attributesData = getAttributes(
        { attributes: selectedAttributes },
        sequence,
        true,
      )
      if (attributesData && attributesData.sequence.length !== 5) {
        attributesData.sequence.push(sequence[attributesData.sequence.length])
      }
      let vehicleMeta = [...vehicleData.meta]
      vehicleMeta = vehicleMeta.map(element => {
        const currentElement = element
        currentElement.isMobile = true
        return currentElement
      })
      getSEOInitialData(attributesData, { meta: vehicleMeta }, [])
        .then(updatedData => {
          if (!isMounted()) { return }
          const data = {
            ...vehicleData,
            meta: updatedData,
            selectedData: selectedAttributes || {},
            isValid: Object.keys(selectedAttributes || {}).length >= 3,
            changeVehicleAction: false,
          }
          setVehicleDataContext(data)
        })
        .catch(() => {
          if (!isMounted()) { return }
          setLoader(false)
          updateVehicles({ changeVehicleAction: false })
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageType, selectedAttributes, isMounted])

  const openVehicleSelector = useCallback((isPlaAndNotYearRange = false) => {
    updateVehicles({
      showVehicleSelector: true,
      overlay: true,
      isPlaAndNotYearRange,
    })
  }, [updateVehicles])

  const handlePLAVehicles = useCallback(openVehicleSelectorFlag => {
    const hasYearRangePla = isYearRangePla(productDetails)
    // For Year range sequence PLA Condition
    if (hasYearRangePla) {
      const sequence = getSequence(hasYearRangePla)
      const attributesData = getAttributes(productDetails, sequence)
      const yearRange = getYearRange(attributesData.attributes.year)
      delete attributesData.attributes.year
      if (Object.keys(attributesData.attributes).length === 5) {
        attributesData.attributes = productDetails.selectedVehicle
      }
      const vehicleDataCopy = deepClone(vehicleData)
      vehicleDataCopy.meta = vehicleDataCopy.meta.map(element => {
        element.isMobile = true
        return element
      })
      getYearRangeInitialData(attributesData, vehicleDataCopy, yearRange).then(
        updatedData => {
          setVehicleData({
            ...vehicleDataCopy,
            meta: updatedData,
            selectedData: attributesData.attributes,
          })
          if (openVehicleSelectorFlag) openVehicleSelector()
        },
      )
    }

    // For Normal(Sequential) PLA Condition
    if (hasYearRangePla) {
      return
    }

    const sequence = getSequence()
    const attributesData = getAttributes(productDetails, sequence)
    if (Object.keys(attributesData.attributes).length === 5) {
      attributesData.attributes = productDetails.selectedVehicle
    }
    vehicleData.meta = vehicleData.meta.map(element => {
      element.isMobile = true
      return element
    })

    const calcNextItem = item => {
      const keyIndex = attributesData.sequence.findIndex(key => item.key === key)
      return keyIndex !== -1 && keyIndex !== attributesData.sequence.length - 1
    }

    getMetaFromAPI(attributesData, vehicleData, years).then(updatedData => {
      const canAddVehicle = canAddVehiclePLA(productDetails)
      if (canAddVehicle) {
        updatedData = updatedData.map(item => ({
          ...item,
          next: calcNextItem(item),
        }))
      }
      const elementKeyToUpdate = sequence[attributesData.sequence.length - 1]
      if (!elementKeyToUpdate) return
      const elementToSelect = getElementByKey(
        updatedData,
        elementKeyToUpdate,
      )
      setVehicleData({
        ...vehicleData,
        meta: updatedData,
        selectedData: attributesData.attributes,
        flag: 'triggerSelect',
        data: {
          elementToSelect,
          value: attributesData.attributes[elementKeyToUpdate],
        },
      })
      flagCheck = true
      if (openVehicleSelectorFlag) openVehicleSelector(true)
    })
  }, [openVehicleSelector, productDetails, vehicleData, years])

  useEffect(() => {
    if (__BROWSER__) {
      window.handlePLAVselector = handlePLAVehicles
    }
  }, [handlePLAVehicles, isPlaPage])

  const resetDefault = useCallback(
    (overlayFlag, isPlaAndNotYearRange) => {
      if (overlayFlag) {
        showVehicleSelector()
        return
      }
      let updatedVehicleDB = deepClone(vehicleState.vehicleDB)
      if (
        isPlaAndNotYearRange &&
        productDetails &&
        productDetails.selectedVehicle &&
        Object.keys(productDetails.selectedVehicle || {}).length >= 3 &&
        vehicleState.isPlaAndNotYearRange
      ) {
        updatedVehicleDB = validateAndUpdateVehicle(
          deepClone(vehicleState.vehicleDB),
          productDetails.selectedVehicle,
        )
      }
      if (updatedVehicleDB && updatedVehicleDB.length) {
        const isPlaAndNotYearRangeObj = vehicleState.isPlaAndNotYearRange
          ? { isPlaAndNotYearRange: false }
          : {}
        addVehicle({
          cartVehicleDB: {},
          showVehicleSelector: false,
          overlay: false,
          vehicleDB: updatedVehicleDB,
          ...isPlaAndNotYearRangeObj,
        })
        updatePLA({
          isPlaUpdateFlag: !isPlaAndNotYearRangeObj.isPlaAndNotYearRangeObj,
        })
      } else {
        addVehicle({
          cartVehicleDB: {},
          overlay: false,
        })
        updatePLA({ isPlaUpdateFlag: false })
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [vehicleState],
  )

  const cleanUpVehicle = useCallback(
    isReset => {
      const vehicleDataClone = { ...vehicleData }
      if (isReset) {
        const hasYearRangePla = isYearRangePla(productDetails)
        resetDefault(false, isPlaPage && !hasYearRangePla)
      }

      // Reset Vehicle meta to default
      let defaultMeta = []
      if (isReset && isSEOPage(pageType, originalDynamicApiData)) {
        const isValid = Object.keys(vehicleDataClone.selectedData).length >= 3
        setVehicleData({
          ...vehicleDataClone,
          isValid,
        })
      } else {
        const defaultSelectBox = deepClone(selectBoxesOriginal)

        defaultMeta = defaultSelectBox.map(element => {
          const elementKey = element.key
          element.open = false
          element.options = elementKey === 'year' ? years : []
          element.disabled = elementKey !== 'year'
          element.value = ''
          return element
        })
        setVehicleData({
          ...vehicleDataClone,
          isValid: false,
          selectedData: {},
          meta: defaultMeta,
        })
      }
    },
    [
      vehicleData, pageType, originalDynamicApiData, productDetails, resetDefault, isPlaPage, selectBoxesOriginal, years,
    ],
  )

  const validateRequiredProps = (requireProps, selectedProps) => {
    const selectedPropKeys = Object.keys(selectedProps) || []
    return requireProps.filter(prop => !selectedPropKeys.includes(prop))
  }
  const updateVehicleStorage = useCallback(
    forceUpdate => {
      // deleting session variable for year range PLA
      if (window.sessionStorage) window.sessionStorage.removeItem('yearRangePLA')

      if (!forceUpdate && !vehicleData.isValid) return ''
      if (pageType === 'account_garage') {
        cleanUpVehicle()
        return addGarageVehicle(vehicleData.selectedData)
      }

      const cartItemVehicle = fromCartItem ? vehicleData.selectedData : {}
      let newVehicleDB = deepClone((vehicleState && vehicleState.vehicleDB) || [])

      if (!fromCartItem) {
        if (newVehicleDB.length) {
          newVehicleDB = validateAndUpdateVehicle(
            newVehicleDB,
            vehicleData.selectedData,
          )
        } else {
          vehicleData.selectedData.selected = true
          newVehicleDB = [vehicleData.selectedData]
        }
      }

      const updatedVehicleDB = {}
      if (fromCartItem) {
        updatedVehicleDB.cartVehicleDB = {
          ...(vehicleState && vehicleState.cartVehicleDB) || {},
          ...cartItemVehicle || {},
        }
        updatedVehicleDB.vehicleDB = newVehicleDB
      } else {
        updatedVehicleDB.vehicleDB = newVehicleDB
      }

      const isSkuPage = (window.pageType || '').includes('sku')

      addVehicle({
        ...updatedVehicleDB,
        showVehicleSelector:
          fromCartItem || (updatedVehicleDB.vehicleDB || []).length === 0,
        overlay: false,
      })
      updatePLA({
        plaFirstLoaded: true,
        isPlaUpdateFlag: isSkuPage && productDetails.isPla,
      })

      setTimeout(() => {
        cleanUpVehicle()
      }, 200)

      if (
        !bypassRoutesForVehicle.includes(pageType) && !vehicleCheckList.includes(pageType)
      ) {
        let pathname = window.location.pathname || history.location.pathname

        const defaultQueryParam = query => (query === ''
          ? queryFactory.getDefaultUrlParam(pageType || pathname)
          : queryFactory.setUrlParam(pageType || pathname, query))

        const query = queryFactory.navigationWithVehicle(
          defaultQueryParam(getSelectedKeyword(serpState)),
          vehicleData.selectedData,
          true,
        )

        if (['make_part', 'make_model_part'].includes(pageType)) {
          const pathnameArray = pathname.split('/').filter(i => i)
          if (pathnameArray && pathnameArray.length > 1) {
            pathname = `/${pathnameArray[0]}`
          }
        }

        // eslint-disable-next-line no-use-before-define
        return !isSkuPage && !fromCartItem
          ? history.push({
            pathname,
            search: query,
          })
          : ''
      }
      const urlQuery = urlSequence.reduce((query, param) => {
        const { [param]: paramValue } = vehicleData.selectedData
        const decoded = paramValue ? `/${urlDecode(paramValue)}` : ''
        return `${query}${decoded}`
      }, '/vehicle')

      // to store vehicle temporary for SEO pages
      if (isSEOPage(pageType, originalDynamicApiData)) {
        window.shortTermVehicle = vehicleData.selectedData
      }
      // eslint-disable-next-line no-use-before-define
      if (!fromCartItem) return history.push(urlQuery)
      return ''
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [vehicleData],
  )

  const onChangeHandler = useCallback(
    (data, selectedElement, vehicleDataInstance) => {
      // Clone state
      const vehicleDataClone = vehicleDataInstance || { ...vehicleData }
      const { selectedData } = vehicleDataClone

      // Update current value
      selectedData[data.key] = String(selectedElement.value)

      // Currently Select Component data
      const currentSelected = findByKey(vehicleDataClone.meta, 'key', data.key)

      // Next Select Component data
      const nextSelect = findByKey(vehicleDataClone.meta, 'key', data.next) || {}

      // clear localstorage for any prevsearch
      // setter("", "vSearch");

      if (!data.next) {
        // Update the Current Select component value to update on UI
        currentSelected.value = String(selectedElement.value)
        vehicleDataClone.isValid = true
        // Update the state
        // setter(JSON.stringify(vehicleDataClone), "vData");
        // setter("", "vSearch");
        setVehicleData({ ...vehicleDataClone })
        updateVehicleStorage(true)

        return
      }

      const isMobileView = __BROWSER__ && window?.innerWidth < 993

      if (isMobileView && !nextSelect.isMobile) {
        nextSelect.isMobile = true
      }
      if (data.key === 'year' && isMobileView) {
        vehicleDataClone.meta = vehicleDataClone.meta.map(element => {
          element.isMobile = true
          return element
        })
      }

      // Update the selected elements based on next selected apiProps
      const newSelectedData = nextSelect.apiProps.reduce((prev, next) => {
        prev[`${next}`] = selectedData[`${next}`]
        return prev
      }, {})

      // update selected data
      vehicleDataClone.selectedData = newSelectedData

      let newUrl = ''

      // Create new url for APi
      const elsSearchApiProps = nextSelect.apiProps.reduce(
        (prevApiProps, next) => {
          // eslint-disable-next-line security/detect-object-injection
          const apiProps = `vehicle[${next}]=${encodeURIComponent(selectedData[next])}`
          return [prevApiProps, apiProps].filter(p => Boolean(p)).join('&')
        },
        '',
      )
      newUrl = elsSearchURL
        .replace('{{api}}', nextSelect.api)
        .replace('{{apiProps}}', elsSearchApiProps)

      axios
        .get(
          newUrl,
          {},
        )
        .then(({ data: responseData }) => {
          let response = null
          // Collect the api response
          if (
            responseData &&
            responseData._payload &&
            responseData._payload.result[nextSelect.api]
          ) {
            response = responseData._payload.result[nextSelect.api]
          }

          // response is null return null
          if (response === null) return

          // Update the Current Select component value to update on UI
          currentSelected.value = String(selectedElement.value)
          const validateRequired = validateRequiredProps(
            requiredSelection,
            vehicleDataClone.selectedData,
          )

          // If no response/data is available
          if (response === 'SUCC6000') {
            vehicleDataClone.isValid = !validateRequired.length
            // setter(JSON.stringify(vehicleDataClone), "vData");
            // setter("", "vSearch");
            setVehicleData({ ...vehicleDataClone })
            updateVehicleStorage(true)
            return
          }
          if (Array.isArray(response.value)) {
            response.value = response.value
              .map(item => item[nextSelect.key])
              .join('|')
          }
          // Update the next select options from response
          nextSelect.options = response.value.split('|')

          // Clean up options and disable
          vehicleDataClone.meta = cleanupOptionAndDisabled(
            vehicleDataClone.meta,
            [...nextSelect.apiProps, ...[nextSelect.key]],
          )
          vehicleDataClone.isValid = !validateRequired.length

          // Update the state
          // setter(JSON.stringify(vehicleDataClone), "vData");
          // setter("", "vSearch");
          setVehicleData({ ...vehicleDataClone })

          // check if response has only single value so that UI and next API call should get called automatically
          if (
            nextSelect.options &&
            nextSelect.options.length &&
            nextSelect.options.length === 1
          ) {
            const [firstOption] = nextSelect.options
            vehicleDataClone.selectedData[nextSelect.key] = firstOption
            // setter(JSON.stringify(vehicleDataClone), "vData");
            // setter("", "vSearch");
            setVehicleData({ ...vehicleDataClone })
            onChangeHandler(nextSelect, { value: nextSelect.options[0] })
            return
          }
          // Open next select component
          const currentSelectedNode = document.getElementById(
            `select-${currentSelected.next}`,
          )
          if (currentSelectedNode) currentSelectedNode.click()
        })
        .catch(err => {
          nrLogger.error('vehicleSelectorFail', err)
          throw err
        })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [vehicleData],
  )

  // Callback After State update
  useEffect(() => {
    const { flag, data = {}, ...rest } = vehicleData
    if (flagCheck && flag && flag === 'triggerSelect') {
      flagCheck = false
      onChangeHandler(data.elementToSelect, { value: data.value }, rest)
      setVehicleData({ ...rest })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicleData])

  const { selectedData } = vehicleData
  const { isValid } = vehicleData
  const positionRelative = useMemo(() => isPlaPage || Boolean(vehicleState.vehicleDB && vehicleState.vehicleDB.length), [isPlaPage, vehicleState.vehicleDB])

  const showVS = useCallback(() => {
    if (isSEOPage(pageType, originalDynamicApiData)) {
      return true
    }

    const pla = isPla(productDetails)
    const fullVehiclePLA = hasFullVehicleInfoPLA(productDetails)
    const fullVehicleNotPLA = hasFullVehicleInfoNotPLA(productDetails)

    const showSelector =
      (vehicleState.showVehicleSelector ||
        !vehicleState.vehicleDB ||
        (vehicleState.vehicleDB && vehicleState.vehicleDB.length === 0)) &&
      (vehicleState.overlay || !pageType.includes('sku') || isDesktop)

    if (pla || fullVehicleNotPLA) {
      return (
        (vehicleState.plaFirstLoaded ||
          vehicleState.overlay ||
          fullVehiclePLA) &&
        showSelector
      )
    }

    return showSelector
  }, [pageType, originalDynamicApiData, productDetails, vehicleState.plaFirstLoaded, vehicleState.showVehicleSelector, vehicleState.vehicleDB, vehicleState.overlay, isDesktop])

  const shouldRender = useMemo(() => ((!isCart && !isIframe) || vehicleState.overlay) ||
      isSEOPage(pageType, originalDynamicApiData), [isCart, isIframe, vehicleState.overlay, pageType, originalDynamicApiData])

  const displayVehicleSelector = noBannerYMMPages.includes(pageType) && showVS()

  if (!shouldRender) {
    return null
  }

  return (
    <VSLayout
      pageType={pageType}
      isHomePage={isHomePage}
      selectBoxData={vehicleData.meta}
      selectedData={selectedData}
      onChangeHandler={onChangeHandler}
      cleanUpVehicle={cleanUpVehicle}
      updateVehicleStorage={updateVehicleStorage}
      showVehicleSelector={displayVehicleSelector}
      isValid={isValid}
      overlay={vehicleState.overlay}
      resetDefault={resetDefault}
      positionRelative={positionRelative}
      width={width}
      showIcon={showIcon}
      showLoader={showLoader}
    />
  )
}

export default memo(SearchBox)
/* eslint-enable max-lines, complexity, max-statements, no-param-reassign, max-len */
